module.exports = __webpack_public_path__ + "static/media/menu-box.ecb9bce4.svg";